/* src/app/umbrella-common/components/password-conditions/password-conditions.style.scss */
.condition-list {
  margin-top: 20px;
}
.condition-list > ul {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(30%, 1fr));
  grid-gap: 20px;
  padding-left: 17px;
}
.condition-list li.condition {
  color: #008238;
  flex-basis: 33%;
}
/*# sourceMappingURL=password-conditions.style.css.map */
